const TimeEnum = Object.freeze({
  hour: 'h',
  minute: 'min',
  second: 'sec',
  day: 'day'
})

export default TimeEnum
